import { createApp } from "vue";
import App from "./App.vue";
import cookie from "vue-cookies";
import router from "./router";
import store from "./store";
import "@/assets/styles/main.css";
import VueImageZoomer from "vue-image-zoomer";
import "vue-image-zoomer/dist/style.css";
import VOtpInput from "vue3-otp-input";

createApp(App)
  .use(store)
  .use(router)
  .use(cookie, {
    secure: true,
  })
  .use(VueImageZoomer)
  .component("v-otp-input", VOtpInput)
  .mount("#app");
